import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { Provider } from '@angular/core';
import { gaHttpErrorInterceptor } from '../interceptors/ga-http-error/ga-http-error.interceptor';

export function provideGAHttpErrorInterceptor(): Provider {
  return [provideHttpClient(withInterceptors([gaHttpErrorInterceptor]))];
}
